// todo refactor
import { FS_URLS } from '../../../../domain/financial-statement/module/financial-statement-routing.module';
import { SOFTWARE_SERVICE } from "../horizontal-nav-bar.component";
import { BUDGET_MODEL_URL } from "../../../../domain/fund-budget-model/pojo/bm-const";

export class URLToHeaderName {
  static urls: { [key: string]: string } = {
    portfolios: 'Portfolio overview',
    'fund-performances': null,
    'portfolio-performance': 'Performance prediction',
    organizations: null,
    'cashflow-matrix': 'Cash on cash & Cashflow matrix',
    'periods-comparison': 'Period comparison',
    portfoliocompanies: 'Portfolio companies',
    documents: 'Portfolio documents',
    'next-round-allocation': 'Holding sensitivity',
    'growth-potential': 'Commitment allocation',
    [BUDGET_MODEL_URL.base]: 'Fund budget',
    'fund-strategy': 'New fund modeling',
    'market-analysis': 'Market analysis',
    'investor-report': 'Investor report',
    kpi: 'KPI',
    financialStatement: 'Financial statement',
    cabinet: 'Account settings',
    'org-user-management': 'Organization & users',
    'org-user-management/org-settings': 'Organization & users',
    'org-user-management/user-settings': 'Organization & users',
    recovery: 'Recovery',
    onboarding: 'Onboarding',
  };

  static getHeaderName(url: string): string {
    return this.urls[url];
  }

  static getServiceName(url: string): SOFTWARE_SERVICE {
    switch (url) {
      case 'portfolios':
        return SOFTWARE_SERVICE.FMS;
      case 'fund-performances':
        return SOFTWARE_SERVICE.FMS;
      case 'portfolio-performance':
        return SOFTWARE_SERVICE.FMS;
      case 'organizations':
        return SOFTWARE_SERVICE.FMS;
      case 'cashflow-matrix':
        return SOFTWARE_SERVICE.FMS;
      case 'periods-comparison':
        return SOFTWARE_SERVICE.FMS;
      case 'portfoliocompanies':
        return SOFTWARE_SERVICE.FMS;
      case 'documents':
        return SOFTWARE_SERVICE.FMS;
      case 'next-round-allocation':
        return SOFTWARE_SERVICE.FMS;
      case 'growth-potential':
        return SOFTWARE_SERVICE.FMS;
      case 'fund-strategy':
        return SOFTWARE_SERVICE.FMS;
      case BUDGET_MODEL_URL.base:
        return SOFTWARE_SERVICE.FMS;
      case 'market-analysis':
        return SOFTWARE_SERVICE.MA;
      case 'investor-report':
        return SOFTWARE_SERVICE.FMS;
      case 'kpi':
        return SOFTWARE_SERVICE.KPI;
      case FS_URLS.base.valueOf():
        return SOFTWARE_SERVICE.FS;
      case 'cabinet':
        return SOFTWARE_SERVICE.UTIL_PAGE;
      case 'user-management':
        return SOFTWARE_SERVICE.UTIL_PAGE;
      case 'recovery':
        return SOFTWARE_SERVICE.UTIL_PAGE;
      case 'onboarding':
        return SOFTWARE_SERVICE.FMS;
      case 'data-room':
        return SOFTWARE_SERVICE.DATA_ROOM;
      case 'investors':
        return SOFTWARE_SERVICE.FMS;
      case 'performance-per-company':
        return SOFTWARE_SERVICE.FMS;
    }
  }
}
